<template lang="html">
  <van-sku
    v-model="showBuyGiftCard"
    :sku="sku"
    :quota="50"
    :goods="goods"
    :goods-id="goodsId"
    :hide-stock="sku.hide_stock"
    :show-add-cart-btn="false"
    add-cart-text=""
    :hide-selected-text="true"
    :buy-text="buyText"
    price-tag="赠送好友"
    :message-config="messageConfig"
    @buy-clicked="onBuyClicked"
    @add-cart="onAddCartClicked"
    @close-preview="closePreview"
    @stepper-change="stepperChanged"
  >
    <!--
    <div slot="sku-header">
    </div>
    -->
    <div slot="sku-header-extra" style="margin-top:20px;">
      {{goods.title}}
    </div>
    <div slot="sku-actions-top" class="total-price">
      合计：<span class="price">¥{{totalPrice}}</span>
    </div>
  </van-sku>
</template>

<script>
import Vue from 'vue'
import { Sku } from 'vant'
Vue.use(Sku)
export default {
  data() {
    return {
      payProcessing: false,
      buyText: '去支付',
      showBuyGiftCard: false,
      goodsId: 0,
      totalPrice: 0,
      sku: {
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
        tree: [
        ],
        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [
          {
            id: 0, // skuId，下单时后端需要
            price: null // 价格（单位分）
          }
        ],
        price: 0, // 默认价格（单位元）
        stock_num: 10000, // 商品总库存
        collection_id: 0, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: true, // 是否无规格商品
        messages: [
          {
            // 商品留言
            datetime: '0', // 留言类型为 time 时，是否含日期。'1' 表示包含
            multiple: '0', // 留言类型为 text 时，是否多行文本。'1' 表示多行
            name: '赠言', // 留言名称
            type: 'text', // 留言类型，可选: id_no（身份证）, text, tel, date, time, email
            required: '1', // 是否必填 '1' 表示必填
            placeholder: '' // 可选值，占位文本
          }
        ],
        hide_stock: true // 是否隐藏剩余库存
      },
      goods: {
        // 默认商品 sku 缩略图
        title: '',
        picture: ''
      },
      messageConfig: {
        initialMessages: {
          赠言: '这期节目你肯定喜欢，送给你听！'
        }
      },
    };
  },
  watch: {
    showBuyGiftCard (newVal, oldVal) {
      if (newVal != oldVal && !newVal) {
        this.$emit('sku-closed')
      }
    },
    show (newVal, oldVal) {
      if (newVal != oldVal && newVal) {
        this.showBuyGiftCard = true
      }
    },
    payProcessing (newVal, oldVal) {
      if (newVal != oldVal) {
        if (newVal) {
          this.buyText = '请稍候...'
        } else {
          this.buyText = '去支付'
        }
      }
    },
    objectId (newVal, oldVal) {
      if (newVal != oldVal && newVal) {
        window.console.log("获得对象ID")
        window.console.log(newVal)
        let that = this
        that.$api.episode.detail(newVal).then(res => {
          const episode = res.data
          that.goods.title = episode.title
          that.sku.price = episode.price.amount / 100
          that.totalPrice = that.sku.price
          that.$api.image.detail(episode.cover).then(res => {
            that.goods.picture = res.data.private_cdns[0].cdn_url
          })
        })
      }
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    objectId: {
      type: Number,
      default: 0
    }
  },
  methods: {
    onBuyClicked (skuData) {
      if (!this.payProcessing) {
        window.console.log(skuData)
        window.console.log(`episode id: ${this.objectId}`)
        let that = this
        that.payProcessing = true
        const params = {
          content_type: 1,
          object_id: that.objectId,
          quota: skuData.selectedNum,
          note: skuData.messages.message_0
        }
        that.$api.giftcard.create(params).then(res => {
          window.console.log("创建礼品卡成功：")
          window.console.log(res.data)
          that.payProcessing = false
          const giftCard = res.data
          // 跳转支付页面
          that.$emit('pay-gift-card', {'giftCardId': giftCard.id})
        }).catch(err => {
          window.console.log("创建礼品卡失败")
          window.console.log(err)
          that.payProcessing = false
        })
      }
    },
    onAddCartClicked () {

    },
    closePreview () {
      window.console.log("关闭图片预览")
    },
    stepperChanged (value) {
      window.console.log(`数量变化： ${value}`)
      let totalPrice = this.sku.price * value
      let totalPriceStr = totalPrice.toString()
      window.console.log(totalPriceStr)
      let index = totalPriceStr.indexOf('.')
      if (index > 0) {
        totalPriceStr = totalPriceStr.slice(0, index + 3)
      }
      this.totalPrice = totalPriceStr
    }
  }
}
</script>

<style lang="css" scoped>
.total-price {
  text-align: center;
}
.price {
  color: #ee0a24;
  font-weight: bold;
}
</style>
